// 路由配置類型定義 - 類似 Vue Router
export interface RouteConfig {
  path: string;
  name: string;
  component: string;
  requiresAuth?: boolean;
  title?: string;
  redirect?: string;
}

// 路由配置表 - 類似 Vue Router 的 routes 配置
export const routeConfigs: RouteConfig[] = [
  {
    path: '/login',
    name: 'Login',
    component: 'Login',
    requiresAuth: false,
    title: '登入',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: 'Dashboard',
    requiresAuth: true,
    title: '戰情看板',
  },
  {
    path: '/vendors',
    name: 'Vendors',
    component: 'VendorManagement',
    requiresAuth: true,
    title: '廠商管理',
  },
  {
    path: '/users',
    name: 'Users',
    component: 'UserManagement',
    requiresAuth: true,
    title: '用戶管理',
  },
  {
    path: '/products',
    name: 'Products',
    component: 'ProductManagement',
    requiresAuth: true,
    title: '產品管理',
  },
  {
    path: '/machines',
    name: 'Machines',
    component: 'MachineManagement',
    requiresAuth: true,
    title: '設備管理',
  },
  {
    path: '/payments',
    name: 'PaymentRecords',
    component: 'PaymentRecords',
    requiresAuth: true,
    title: '付款記錄',
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: 'Announcements',
    requiresAuth: true,
    title: '公告管理',
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: 'Maintenance',
    requiresAuth: true,
    title: '維運管理',
  },
  {
    path: '/machine-log-statistics',
    name: 'MachineLogStatistics',
    component: 'MachineLogStatistics',
    requiresAuth: true,
    title: '機台異常統計',
  },
  {
    path: '/locations',
    name: 'Locations',
    component: 'LocationManagement',
    requiresAuth: true,
    title: '地點管理',
  },
  {
    path: '/updatelog',
    name: 'UpdateLog',
    component: 'UpdateLogList',
    requiresAuth: true,
    title: '更新日誌',
  },
  {
    path: '/updatelogmanage',
    name: 'UpdateLogManage',
    component: 'UpdateLogManage',
    requiresAuth: true,
    title: '管理更新日誌',
  },
  {
    path: '/',
    name: 'Home',
    component: '',
    requiresAuth: true,
    redirect: '/dashboard',
  },
];

// 路由名稱映射 - 方便程式化導航
export const routeNames = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  VENDORS: '/vendors',
  USERS: '/users',
  ANNOUNCEMENTS: '/announcements',
  PRODUCTS: '/products',
  MACHINES: '/machines',
  TRANSACTION_RECORDS: '/transactions',
  MAINTENANCE: '/maintenance',
  LOCATIONS: '/locations',
  CHANGELOG: '/updatelog',
  CHANGELOG_MANAGE: '/updatelogmanage',
  MACHINE_LOG_STATISTICS: '/machine-log-statistics',
} as const;

// 獲取路由元信息
export const getRouteMeta = (path: string) => {
  return routeConfigs.find(route => route.path === path);
};

// 檢查路由是否需要認證
export const requiresAuth = (path: string): boolean => {
  const route = getRouteMeta(path);
  return route?.requiresAuth ?? true;
};
